import { CloseOutlined } from '@ant-design/icons';
import { message as staticMessage } from 'antd';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import styles from './index.module.css';

/** Set by AntdAppMessageBridge so static callers pick up ConfigProvider theme via App.useApp(). */
let messageApi = null;

export const setNotificationMessageApi = (api) => {
  messageApi = api;
};

export const showNotificationMessage = ({ type, content, duration, onClose }) => {
  const key = uuidv4();
  const api = messageApi || staticMessage;
  const handleClose = () => api.destroy(key);

  return api[type]({
    key,
    content: (
      <div className={styles.notification}>
        {content}
        <CloseOutlined className={styles.closeIcon} onClick={handleClose} />
      </div>
    ),
    duration: duration || 3,
    onClose,
    className: styles.message,
  });
};
